var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Alert, Button, DrawerBody, DrawerFooter, DrawerHeader, FormController, FormLabel, Input, LoadingButton, Radio, RadioGroup, SelectionControlLabel, Typography, } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ExportPurchaseHistory, PurchaseHistoryOfflineDownload, } from '../../../api/oms/order-history';
import { getFeatureSwitchValue, getWindow, redirectToDownloadsPage, } from '../../../utils/general';
import { pushPurchaseHistoryHeaderButtonEvent, setExportHistoryError, } from '../../../utils/purchase-history/analytics';
import { useCommonContext } from '../../../hooks/useContexts';
export var ExportCSVForm = function (_a) {
    var closeDrawer = _a.closeDrawer, setAlertState = _a.setAlertState, _b = _a.orderHistoryRequest, _c = _b.customerAccountId, customerAccountId = _c === void 0 ? '' : _c, endDate = _b.endDate, pageNumber = _b.pageNumber, pageSize = _b.pageSize, _d = _b.resultsFilter, resultsFilter = _d === void 0 ? '' : _d, searchBy = _b.searchBy, _e = _b.searchType, searchType = _e === void 0 ? 'ORDERS' : _e, _f = _b.sortBy, sortBy = _f === void 0 ? '' : _f, _g = _b.sortOrder, sortOrder = _g === void 0 ? 'asc' : _g, startDate = _b.startDate, totalNumberOfOrders = _a.totalNumberOfOrders;
    var _h = useState('success'), inputError = _h[0], setInputError = _h[1];
    var _j = useState(false), isLoading = _j[0], setIsLoading = _j[1];
    var timezone = useCommonContext().timezone;
    var generateDefaultFileName = function () {
        var _a, _b;
        var dateTime = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        }).format(new Date());
        var _c = dateTime ? dateTime.split('at') : ['', ''], date = _c[0], time = _c[1];
        var formattedDate = (_a = date === null || date === void 0 ? void 0 : date.slice(0, -1)) === null || _a === void 0 ? void 0 : _a.replace(/[\s,]+/g, '-');
        var formattedTime = (_b = time === null || time === void 0 ? void 0 : time.slice(1)) === null || _b === void 0 ? void 0 : _b.replace(' ', '-').replace(':', '-');
        return "Purchase_History_".concat(formattedDate, "_").concat(formattedTime, ".csv");
    };
    var _k = useForm({
        mode: 'onBlur',
        defaultValues: {
            dataType: 'SummaryData',
            fileName: generateDefaultFileName(),
        },
    }), control = _k.control, errors = _k.formState.errors, handleSubmit = _k.handleSubmit, register = _k.register, reset = _k.reset, watch = _k.watch;
    var watchFileName = watch('fileName');
    useEffect(function () {
        if (errors.fileName || watchFileName === '') {
            setInputError('error');
            return;
        }
        if (inputError === 'error') {
            setInputError('');
        }
    }, [errors, watchFileName]);
    var getCompleteFileName = function (fileName) {
        var endsWithCSV = fileName.includes('.csv');
        return endsWithCSV ? fileName : "".concat(fileName, ".csv");
    };
    var parseBlob = function (blobText, contentType) {
        return new Blob([blobText], { type: contentType });
    };
    var openFile = function (blob, fileName) {
        var _a, _b;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.navigator).msSaveBlob) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator).msSaveOrOpenBlob(blob, fileName);
        }
        else {
            var add_1 = document.createElement('a');
            document.body.appendChild(add_1);
            add_1.setAttribute('style', 'display: none');
            var url = (window.URL || window.webkitURL).createObjectURL(blob);
            add_1.href = url;
            add_1.download = fileName;
            add_1.click();
            setTimeout(function () {
                add_1.remove();
            }, 100);
        }
    };
    var saveFile = function (data, fileName) {
        var blob = parseBlob(data, 'data:application/csv,');
        return openFile(blob, fileName);
    };
    var closeAlert = function () {
        if (setAlertState)
            setAlertState(null);
    };
    var handleSuccessfulRequest = function (response, fileName) {
        setAlertState({
            alertMessage: 'Purchase History Data successfully exported. Please check your downloads folder for the file.',
            status: 'success',
            onClose: closeAlert,
        });
        if (response.data) {
            var completeFileName = getCompleteFileName(fileName);
            saveFile(response.data, completeFileName);
        }
    };
    var enableAlertError = function () {
        setAlertState({
            alertMessage: "We're Sorry. We are unable to export your data. Please try again later.",
            status: 'error',
        });
    };
    var handleStandardExport = function (data) {
        var request = {
            orderHistoryRequest: {
                customerAccountId: customerAccountId,
                endDate: endDate,
                pageNumber: pageNumber,
                pageSize: pageSize,
                resultsFilter: resultsFilter,
                searchBy: searchBy,
                searchType: searchType,
                sortBy: sortBy,
                sortOrder: sortOrder,
                startDate: startDate,
                includeDetails: data.dataType === 'DetailsData',
                exportType: 'csv',
                timezone: timezone,
            },
        };
        ExportPurchaseHistory(request)
            .then(function (response) {
            if (response.status && response.data) {
                handleSuccessfulRequest(response, data.fileName);
            }
            if (!(response === null || response === void 0 ? void 0 : response.status)) {
                enableAlertError();
            }
        })
            .catch(function (error) {
            enableAlertError();
            setExportHistoryError(error);
        })
            .finally(function () {
            setIsLoading(false);
            setInputError('');
            reset();
            closeDrawer();
        });
    };
    var handleOfflineDownloadExport = function (data) {
        var payload = {
            orderHistoryRequest: {
                customerAccountId: customerAccountId,
                startDate: startDate,
                endDate: endDate,
                includeDetails: data.dataType === 'DetailsData',
                searchType: searchType,
                pageSize: pageSize,
                pageNumber: pageNumber,
                searchBy: searchBy,
                sortBy: sortBy,
                sortOrder: sortOrder,
                resultsFilter: resultsFilter,
                fileName: data.fileName.replace('.csv', ''),
                timezone: timezone,
            },
            offlineProcessRequestType: 'PURCHASE_HISTORY_EXPORT',
            downloadType: 'CSV',
        };
        PurchaseHistoryOfflineDownload(payload)
            .then(function (response) {
            if (response) {
                redirectToDownloadsPage('orderHistoryRedirect');
            }
        })
            .catch(function () {
            setIsLoading(false);
            setAlertState({
                alertMessage: "We're Sorry. We are unable to export your data. Please try again later.",
                status: 'error',
            });
        });
    };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var phThreshold;
        return __generator(this, function (_a) {
            setInputError('success');
            setIsLoading(true);
            pushPurchaseHistoryHeaderButtonEvent("export ".concat(data.dataType === 'DetailsData' ? 'details' : 'summary'));
            phThreshold = getFeatureSwitchValue('phOfflineDownloadThreshold') || 4000;
            if (totalNumberOfOrders >= phThreshold) {
                handleOfflineDownloadExport(data);
            }
            else {
                handleStandardExport(data);
            }
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": "exportCSV" },
            React.createElement(DrawerHeader, { title: "Export Account History", onClose: closeDrawer }),
            React.createElement(DrawerBody, null,
                React.createElement("div", { style: { height: '80vh' } },
                    React.createElement("div", { className: " sui-mb-6" },
                        React.createElement(Alert, { status: "info", size: "large" },
                            "Exported data will only show settled transactions. ",
                            React.createElement("br", null),
                            "Returns and cancellations will not show in exported data.")),
                    React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Select data to export"),
                    React.createElement(Controller, { control: control, name: "dataType", rules: { required: true }, render: function (_a) {
                            var field = _a.field;
                            return (React.createElement(RadioGroup, __assign({}, field),
                                React.createElement(SelectionControlLabel, { label: "Summary Data", value: "SummaryData" },
                                    React.createElement(Radio, null)),
                                React.createElement(SelectionControlLabel, { label: "Details Data", value: "DetailsData" },
                                    React.createElement(Radio, null))));
                        } }),
                    React.createElement("div", { className: "sui-my-3" },
                        React.createElement(Typography, { variant: "body-base", color: "subtle" }, "Data will be exported as a csv file.")),
                    React.createElement(FormController, { fullWidth: true, status: inputError },
                        React.createElement(FormLabel, { htmlFor: "fileName" }, "Filename"),
                        React.createElement(Input, __assign({}, register('fileName', { required: true }), { "aria-describedby": "fileName-input", fullWidth: true }))),
                    errors.fileName && (React.createElement(Typography, { variant: "body-xs", color: "danger" }, "Please enter a filename.")))),
            React.createElement(DrawerFooter, null,
                React.createElement("div", { className: "ButtonGroup sui-min-w-full sui-flex sui-gap-4 sui-flex-col" },
                    React.createElement(LoadingButton, { onClick: handleSubmit(onSubmit), loading: isLoading, variant: "primary", disabled: errors.fileName || watchFileName === '' }, "Export"),
                    React.createElement(Button, { onClick: closeDrawer, variant: "secondary", disabled: isLoading }, "Cancel"))))));
};
